// Google Ads Tracking - Production Only
// This utility conditionally loads Google Ads gtag.js tracking code
// only when running in the production environment (vatesdomusai.com)

import { getEnvironment } from '../config/apiKeys.js';

const GOOGLE_ADS_ID = 'AW-17807636696';
let isInitialized = false;


// Format: 'AW-17807636696/YourConversionLabel'
// Get these from: ads.google.com → Tools & Settings → Conversions
export const CONVERSION_LABELS = {
  CONTACT_FORM: 'AW-17807636696/BphTCM2s6t8bENjxq6tC', // Submit lead form conversion label
  SIGN_UP: 'AW-17807636696/Imd-CMTt4-kbENjxq6tC', // Sign-up conversion label
  OUTBOUND_CLICK: 'AW-17807636696/kF3ZCMLD9d8bENjxq6tC', // Outbound click conversion label
  HOME_PAGE_VIEW: 'AW-17807636696/a8_ZCMGy8ekbENjxq6tC' // Home page view conversion label
};

/**
 * Initialize Google Ads tracking by injecting the gtag.js scripts
 * into the document head. Only runs in production environment.
 */
export function initializeGoogleAdsTracking() {
  // Only initialize once
  if (isInitialized) {
    return;
  }

  // Only load in production environment
  const environment = getEnvironment();
  if (environment !== 'production') {
    return;
  }

  // Check if scripts are already present (safety check)
  if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}"]`)) {
    isInitialized = true;
    return;
  }

  // Inject the async gtag.js script
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
  document.head.appendChild(script1);

  // Inject the inline gtag initialization script
  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GOOGLE_ADS_ID}');
  `;
  document.head.appendChild(script2);

  isInitialized = true;
}

/**
 * Track a page view
 * @param {string} pagePath - The path of the page (e.g., '/pricing', '/contact')
 */
export function trackGoogleAdsPageView(pagePath) {
  const environment = getEnvironment();
  if (environment !== 'production') {
    return;
  }

  if (typeof window.gtag === 'function') {
    window.gtag('config', GOOGLE_ADS_ID, {
      page_path: pagePath
    });
  }
}

/**
 * Track a Google Ads conversion event
 * @param {string} conversionLabel - The conversion label (e.g., 'AW-17807636696/AbCdEfGhIjKlMnOpQrStUvWxYz123456')
 * @param {number|null} value - Optional conversion value
 * @param {string} currency - Currency code (default: 'USD')
 */
export function trackGoogleAdsConversion(conversionLabel, value = null, currency = 'USD') {
  const environment = getEnvironment();
  if (environment !== 'production') {
    return;
  }

  if (!conversionLabel) {
    console.warn('Google Ads conversion tracking: No conversion label provided');
    return;
  }

  if (typeof window.gtag === 'function') {
    const conversionData = {
      'send_to': conversionLabel
    };

    if (value !== null && value !== undefined) {
      conversionData['value'] = value;
      conversionData['currency'] = currency;
    }

    window.gtag('event', 'conversion', conversionData);
    console.log('✅ Google Ads conversion tracked:', conversionLabel);
  } else {
    console.warn('Google Ads conversion tracking: gtag not available');
  }
}

